import UpdateIcon from 'app/ui/icons/UpdateIcon';
import { useEffect, useState } from 'react';

import { Box, Button, Card, CardContent, makeStyles, Theme, Typography, useMediaQuery, useTheme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    background: 'rgba(33, 58, 109, 0.75)',
    zIndex: 10000,
  },
}));

export default function UpdateOverlay() {
  const [open, setOpen] = useState(false);

  const onVersionCheck = (e: any) => {
    if (!e.detail.isMatch) {
      setOpen(true);
    }
  };

  useEffect(() => {
    document.addEventListener('versionCheck', onVersionCheck, false);

    return () => {
      document.removeEventListener('versionCheck', onVersionCheck);
    };
  });

  const classes = useStyles();

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));

  if (!open) {
    return null;
  }

  const onReload = () => {
    window.location.reload();
  };

  return (
    <Box
      className={classes.root}
      display={open ? 'flex' : 'none'}
      justifyContent="center"
      alignItems="center"
    >
      <Box maxWidth={700}>
        <Card>
          <CardContent>
            {!matches && (
              <Box
                mb={1}
                fontSize="10rem"
                display="flex"
                justifyContent="center"
              >
                <UpdateIcon fontSize="inherit" />
              </Box>
            )}
            <Box textAlign="center">
              <Typography variant="h2">
                A new version of Tertius is available
              </Typography>
            </Box>
            <Box fontSize="2.4rem" textAlign="center">
              <p>Please update by clicking the button below.</p>
            </Box>
            <Box width="100%" display="flex" justifyContent="center">
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  onReload();
                }}
              >
                Update application
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
}
